import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CountryArrayModel, CountryModel } from "../../models/CountryModel";

const initialCountryState: CountryArrayModel = {
  all_Countries: [],
  particular_Country: {
    countryName: "",
    countryCode: "",
  },
  isCountriesFetching: false,
};
const CountrySlice = createSlice({
  name: "Country",
  initialState: initialCountryState,
  reducers: {
    setAllCountries(state, action: PayloadAction<CountryModel[]>) {
      state.all_Countries = action.payload;
    },
    setParticularCountry(state, action: PayloadAction<CountryModel>) {
      state.particular_Country = action.payload;
    },
    setIsCountriesFetching(state, action: PayloadAction<boolean>) {
      state.isCountriesFetching = action.payload;
    },
  },
});
export default CountrySlice;
